import { render, staticRenderFns } from "./BaseListPage.vue?vue&type=template&id=f71049ca&scoped=true"
import script from "./BaseListPage.vue?vue&type=script&lang=js"
export * from "./BaseListPage.vue?vue&type=script&lang=js"
import style0 from "./BaseListPage.vue?vue&type=style&index=0&id=f71049ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71049ca",
  null
  
)

export default component.exports